function adapterOptions(dataFromAPI, lang = 0){
  if(dataFromAPI && dataFromAPI.length > 0){
    return dataFromAPI.map(a => {
      return {
        label: a.nama[lang],
        value: a.id
      }
    })
  }

  return []
}

export { adapterOptions }
